import { MemoryUserEngagementRepository } from "./memoryUserEngagementRepository";
import { UserEngagementQuery } from "../application/UserEngagementQuery";
import { APIUserEngagementRepository } from "./apiUserEngagementRepository";

export function getUserEngagementData(): UserEngagementQuery {
  const repository = new MemoryUserEngagementRepository();
  return new UserEngagementQuery(repository);
}

export function getUserEngagementDataApi(): UserEngagementQuery {
  const repository = new APIUserEngagementRepository();
  return new UserEngagementQuery(repository);
}
